import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Pages
import BrandingLanding from './components/BrandingLanding';
import StartProject from './pages/StartProject';
import SignupPage from './components/auth/SignupPage';
import DashboardHome from './components/dashboard/DashboardHome';
import AnalyticsView from './components/dashboard/AnalyticsView';
import DataManagement from './components/dashboard/DataManagement';
import BillingView from './components/dashboard/BillingView';
import AccountSettings from './components/dashboard/AccountSettings';
import ScrollToTop from './components/ScrollToTop';
import AboutPage from './pages/AboutPage';

// Auth
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import PurgatoryPage from './pages/PurgatoryPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>

          {/* ── PUBLIC routes — no login required ────────────────────── */}
          <Route path="/" element={<BrandingLanding />} />
          <Route path="/start-a-project" element={<StartProject />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/build-for-me" element={<Navigate to="/start-a-project" replace />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/purgatory" element={<PurgatoryPage />} />

          {/* ── INTERNAL / CORPORATE routes — staff login required ────── */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<DashboardHome />} />
            <Route path="/analytics" element={<AnalyticsView />} />
            <Route path="/data" element={<DataManagement />} />
            <Route path="/billing" element={<BillingView />} />
            <Route path="/account" element={<AccountSettings />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
